import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { activatedPromocodeSchema } from '../types';

export type ActivatePromocodeMutationParams = {
	playerId: number;
	code: string;
};

export const createActivatePromocodeMutation = () =>
	createAuthMutation({
		params: declareParams<ActivatePromocodeMutationParams>(),
		request: {
			method: 'PATCH',
			url: '/device/voucher/activate',
			body: (data) => data,
		},
		response: {
			contract: zodContract(activatedPromocodeSchema),
		},
	});
